<template>
  <el-dialog title="安装计划详情" :visible.sync="editInstallPlanFormVisible" class="dialog_block" width="600" height="500" :close-on-click-modal="false">
    <el-form
      ref="installPlanForm"
      label-width="100px"
      class="demo-dynamic"
    >
      <el-form-item label="计划日期" prop="planDate">
        {{installPlanForm.planDate}}
      </el-form-item>
      <el-form-item label="工人配置" prop="planDate">
        <el-col :span="12">
        <el-form-item label="安装工:">
          {{installPlanForm.anzhuangNum}}
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="搬运工:">
          {{installPlanForm.banyunNum}}
        </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="安装内容" prop="content">
       {{installPlanForm.content}}
      </el-form-item>
      <el-form-item label="加班安排"  prop="workOvertime">
        {{installPlanForm.workOvertime==0?"无需加班":"需要加班"}}

      </el-form-item>
    </el-form>
    <hr>

  </el-dialog>
</template>

<script>
import { objKeySort } from "@/util/ajaxsign";
export default {
  name: "editBasePlan",
  data() {
    return {
      editInstallPlanFormVisible: false,
      dialogTitle: "添加安裝计划",
      typeId:0,
      installPlanForm: {
        id: "",
        content: "",
        planDate: ""
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= new Date().getTime() - 86400000;
        }
      },
      rules: {
        planDate: [{ required: true, message: "请填写安裝日期", trigger: "blur" }],
        content: [{ required: true, message: "请填写安裝内容", trigger: "blur" }]
      }
    };
  },
  created() {

  },
  filters: {

  },
  methods: {

    //选择开工时间
    changeTableDate(e) {
      let that = this
      console.log("勘察日期：",e);
      that.installPlanForm.planDate = e
    },


    setData(data) {
      debugger
      this.editInstallPlanFormVisible = true;
      this.cleanForm();
      if (data) {
        this.installPlanForm = data;

      }
    },
    save(type) {
       let that =this
      that.$refs.installPlanForm.validate(valid => {
        if (valid) {
          that.$emit("setContent", 3,that.installPlanForm);
          if (type == 1) {
            that.close();
          } else {
            that.cleanForm();
          }
        } else {
          return false;
        }
      });
    },

    close() {
      this.editInstallPlanFormVisible = false;
      this.cleanForm();
    },
    cleanForm() {

        if(this.$refs.installPlanForm){
          this.$refs.installPlanForm.clearValidate();

          this.installPlanForm = {
            id: "",
            planDate:"",
            content: "",
            index:-1

          };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .mb_7{
    margin-bottom: 7px;
  }
  .width_80{
    width: 80px;
    margin-top: 0;
  }
  .el-button{
   padding: 1px 16px;
  }
  .el-upload--picture-card{
    width: 125px;
    height: 125px;
    border-radius:3px;
    border:1px solid rgba(237,239,242,1);
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }
  .el-upload-list__item{
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }

  .foot_span{
    text-align: right;
    margin-right: 56px;
  }
  hr {
    bottom: 72px;
    border-color: rgba(245, 247, 250, 0.2);
    margin-bottom: 15px;
  }
  .el-dialog__body{
    padding: 0 !important;
  }
  .el-upload-list__item:first-child{
    margin-top: 0 !important;
  }
  .el-form-item{
    margin-bottom: 0px!important;
  }
</style>
